export const types = [
  { text: 'Producto', value: 'Producto' },
  { text: 'Servicio', value: 'Servicio' },
];

export const invoiceTypes = [{ text: 'Venta', value: 'Venta' }, { text: 'Gasto', value: 'Gasto' }];
